import "shared-components/ViewFragments/ProjectEspecialSingle/style.less";

import { BreadCrumbs } from "shared-components/Components/SEO/BreadCrumbs/web";
import { SeoText } from "shared-components/Components/SEO/SeoText/web";
import { Button, Card, Col, Grid, Row, Space, Typography } from "antd";
import { HeartFilled, WhatsAppOutlined } from "@ant-design/icons";
import { FacebookIcon } from "shared-components/Components/CustomIcons/FacebookIcon/web";
import { TwitterIcon } from "shared-components/Components/CustomIcons/TwitterIcon/web";
import { LocationOutlinedIcon } from "shared-components/Components/CustomIcons/LocationOutlinedIcon/web";
import { OnScreen } from "shared-components/Components/OnView/web";
import React, { useContext, useEffect, useState } from "react";
import { isTemporal } from "shared-components/Utils/Functions";

import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { Description } from "shared-components/Components/Property/Description/web";
import { Facilities } from "shared-components/Components/Property/Facilities/web";
import { InformationRequest } from "shared-components/Components/Property/InformationRequest/web";
import { ListingTypeTag } from "shared-components/Components/Property/ListingTypeTag/web";
import { LocationTag } from "shared-components/Components/Property/LocationTag/web";
import { Navigation } from "shared-components/ViewFragments/PropertyDetails/Navigation/web";
import { OfficeHours } from "shared-components/Components/OfficeHours/web";
import { PriceTag } from "shared-components/Components/Property/PriceTag/web";
import { ProjectInfo } from "shared-components/Components/Project/Info/web";
import { PropertyAffixBottom } from "shared-components/ViewFragments/PropertyDetails/PropertyAffixBottom/web";
import { PropertyAffixHeader } from "shared-components/ViewFragments/PropertyDetails/PropertyAffixHeader/web";
import { PropertyCover } from "shared-components/ViewFragments/PropertyDetails/PropertyCover/web";
import { PropertyLocalInformationMap } from "shared-components/ViewFragments/PropertyDetails/PropertyLocalInformation/web";
import { StarFilled } from "@ant-design/icons";
import { Subsidiaries } from "shared-components/Components/Property/Subsidiaries/web";
import { TypologyTag } from "shared-components/Components/Property/TypologyTag/web";
import { Units } from "shared-components/Components/Project/Units/web";
import dynamic from "next/dynamic";
import { useMarkSeen } from "shared-components/Components/Property/SeenStatus/SeenStatus.hook";
import { useSocialShare } from "shared-components/Components/Property/SocialShare/hook";
import { useTheme } from "shared-components/Styles/ThemeHook";
import { CloseButton } from "shared-components/Components/CustomIcons/CloseButton/web";
import { EventBanner } from "src/Components/Eventos/EventBanner/web";
import { firstLetterToUppercase, getProjectCommertialUnitsOrdered, getProjectRangePrices } from "src/utils/Functions";
import { useContactModal } from "shared-components/Contexts/ContactModal/context";
import { ModalConsulta } from "shared-components/Components/Property/InformationRequest/LeadButtons/FormButton/ModalConsulta";
import { useIsAuthModalShowing } from "shared-components/GlobalHooks/useIsAuthModalShowing";
import Head from "next/head";
import Header from "RefactorSearchPage/Header/web";
import { PicHomeFooter } from "shared-components/ViewFragments/Footer/PicHomeFooter/web";
import { Footer } from "shared-components/ViewFragments/Footer/web";
import { OwnerInfo } from "shared-components/Components/Property/OwnerInfo/web";
import { PropertySimilarsCards as PropertySimilarsCardsActive } from "shared-components/ViewFragments/PropertyDetails/PropertySimilars/PropertySimilarsCards/web";
import usePropertyData from "src/hooks/propertyData/usePropertyData";

const { Text } = Typography;
const { useBreakpoint } = Grid;
const Modal = dynamic((): any => import("antd").then(mod => mod.Modal), { ssr: false });
//@ts-ignore
const PropertySimilarsCards = dynamic(
	(): any =>
		import(
			"shared-components/ViewFragments/PropertyDetails/PropertySimilars/PropertySimilarsCards/web"
		).then(mod => mod.PropertySimilarsCards),
	{ ssr: false }
);

export const ProjectSpecial = (props) => {
    const mode = "project";
	const id = props.__PROJECT__ID__;
	const { listing } = usePropertyData();
	const { theme } = useTheme();
	const { markSeen } = useMarkSeen();
	const { site_name, translations } = useContext(ConfigStateContext);
    const { isVisible, modalData, closeContactModal, openContactModal } = useContactModal();
    const { isAuthModalShowing } = useIsAuthModalShowing();
	const { socialMediaLink } = useSocialShare({ id: listing.id, mode });
	const screen = useBreakpoint();

	const [modalTabOpen, setModalTabOpen] = useState("photos");
	const [isModalOpen, setModalOpen] = useState(false);
	const [showAffix, setShowAffix] = useState(false);
	const [showAffixBottom, setShowAffixBottom] = useState(true);
    const [minAndMaxUnits, setMinAndMaxUnits] = useState<any>({});

	const ImgBackup = listing.backup_img?.split(";");
	const operationTypeId = listing.operation_type?.id;
	const propertyTypeId = listing.property_type?.id;
	const socialMediaIcons = Object.freeze({
		Facebook: <FacebookIcon />,
		Twitter: <TwitterIcon />,
		WhatsApp: <WhatsAppOutlined />,
	});

	const PropertyModal = dynamic(
		(): any =>
			import("shared-components/ViewFragments/PropertyDetails/PropertyModal/web").then(
				mod => mod.PropertyModal
			),
		{ ssr: false }
	);

	useEffect(() => {
		markSeen(id, "PROJECT");
	}, []);

    useEffect(() => {
        if (listing.id) {

            if (Array.isArray(listing.commercial_units) && !!listing.commercial_units.length) {
                let commercialUnits = getProjectCommertialUnitsOrdered({ listing });
                const prices = getProjectRangePrices({ listing });
                const minUnit = { ...commercialUnits?.[0], price: prices.minPrice };
                const maxUnit = {
                    ...commercialUnits[commercialUnits.length - 1],
                    price: prices.maxPrice,
                };

                setMinAndMaxUnits({ minUnit, maxUnit });
            }
        }
    }, [listing]);

    return (
        <>
            {!listing.active && (
				<Head>
					<meta name="robots" content="noindex, nofollow" />
				</Head>
			)}

            <div className="project-especial-single">
			    <Header showSearchBar={false} showArrow={false} />

                <div className="project-detail">
                    {/* Show Affix && Property Affix Header */}
                    {showAffix && screen.lg && (
                        <PropertyAffixHeader id={listing.id} listing={listing} mode={mode} />
                    )}

                    {/* Property Modal */}
                    {listing?.active && (
                        <Modal
                            className="pd-property-modal"
                            visible={isModalOpen}
                            centered
                            footer={null}
                            closeIcon={<CloseButton />}
                            onCancel={() => setModalOpen(false)}>
                            <PropertyModal
                                activeTab={modalTabOpen}
                                onChangeTab={tab => setModalTabOpen(tab)}
                                propId={id}
                                mode={mode}
                                listing={listing}
                                isDisabledProperty={!listing.active}
                            />
                        </Modal>
                    )}

                    {listing.project &&
                        !!listing.project.length &&
                        listing.project[0].event &&
                        listing.project[0].event.show && (
                            <EventBanner
                                link={listing.project[0].event.link}
                                logo={listing.project[0].event.logo}
                                date={listing.project[0].event.startDate}
                            />
                        )}

                    <Row className="main">
                        {/* Navigation */}
                        {screen.lg && (
                            <Col span={0} lg={24} className="navigation">
                                <div className="container">
                                    <Navigation type="default" />
                                </div>
                            </Col>
                        )}

                        {/* In Active Prop Declaimer */}
                        {!listing.active && (
                            <>
                                <Col span={24} className="is-disabled-property">
                                    <div className="container">
                                        <Card
                                            bodyStyle={{
                                                background: theme.colors.warningColor,
                                            }}>
                                            <Typography.Title
                                                style={{ margin: 0, textAlign: "center" }}
                                                level={5}>
                                                {
                                                    "Estás viendo esta página porque la propiedad que estabas buscando no está disponible."
                                                }
                                            </Typography.Title>
                                        </Card>
                                    </div>
                                </Col>

                                <Col span={24} className="similar-container">
                                    <div className="container ">
                                        <PropertySimilarsCards id={listing.id} mode={mode} />
                                    </div>
                                </Col>
                            </>
                        )}

                        {/* Top Informatión Desktop */}
                        <Col span={0} lg={24} className="top-information ">
                            <div className="container top-information-container">
                                <div className="information-left">
                                    <div className="logo-tags-container">
                                        <div className="logo">
                                            <img src={listing.owner?.logo} alt={listing.owner?.name} />
                                        </div>
                                        <ListingTypeTag id={listing.id} />
                                    </div>
                                    <Typography.Title className="title">
                                        {listing.title}
                                    </Typography.Title>
                                    <Typography.Title className="sub-title" level={5}>
                                        {listing.subtitle}
                                    </Typography.Title>
                                    <div className="address">
                                        <LocationOutlinedIcon />
                                        <LocationTag />
                                    </div>
                                </div>
                                <div className="information-right">
                                    <Space className="rrss">
                                        {socialMediaLink && (
                                            <Space>
                                                <Button
                                                    className="secondary"
                                                    href={`https://www.facebook.com/sharer/sharer.php?u=${socialMediaLink}`}
                                                    target={"_blank"}
                                                    icon={socialMediaIcons.Facebook}
                                                />
                                                <Button
                                                    className="secondary"
                                                    href={`https://twitter.com/intent/tweet?text=${encodeURI(
                                                        `Mira esta propiedad de ${site_name}`
                                                    )}&url=${socialMediaLink}&hashtags=${site_name},${"Propiedad"}`}
                                                    target={"_blank"}
                                                    icon={socialMediaIcons.Twitter}
                                                />
                                                <Button
                                                    className="secondary"
                                                    href={`https://wa.me/?text=${encodeURI(
                                                        `Mira esta propiedad de ${site_name}: \n${socialMediaLink}`
                                                    )}`}
                                                    target={"_blank"}
                                                    icon={socialMediaIcons.WhatsApp}
                                                />
                                            </Space>
                                        )}
                                    </Space>
                                    {!isTemporal(operationTypeId) ? (
                                        <PriceTag
                                            showOperationType={true}
                                            shortExpensesText={false}
                                            mode={mode}
                                            price={
                                                listing.isProject
                                                    ? minAndMaxUnits.minUnit
                                                            ?.price
                                                    : listing.price
                                            }
                                            maxPrice={
                                                listing.isProject
                                                    ? minAndMaxUnits.maxUnit
                                                            ?.price
                                                    : null
                                            }
                                            priceVariation={listing.price_variation}
                                            commonExpenses={listing.commonExpenses}
                                            temporalCurrency={listing.temporal_currency}
                                            temporalPrice={listing.temporal_price}
                                            operationType={listing.operation_type}
                                            isProject={listing.isProject}
                                        />
                                    ) : null}
                                </div>
                            </div>
                        </Col>

                        {/* Property Cover */}
                        <Col span={24} className="property-cover">
                            <OnScreen
                                onEnterView={() => setShowAffix(false)}
                                onLeaveView={() => setShowAffix(true)}>
                                {/* Property Cover */}
                                <div className="container pe-container">
                                    <PropertyCover
                                        isEspecial={listing.isEspecial}
                                        tour3d={listing.tour3d}
                                        images={listing.images}
                                        img={listing.img}
                                        isProject={listing.isProject}
                                        mode={mode}
                                        id={listing.id}
                                        onTabClick={tab => {
                                            setModalTabOpen(tab);
                                            setModalOpen(true);
                                        }}
                                        files={listing.files}
                                        youtube={listing.isProject ? listing.video : listing.youtube}
                                        latitude={listing.latitude}
                                    />
                                </div>
                            </OnScreen>
                        </Col>

                        {/* Top Informatión Desktop */}
                        <Col span={24} lg={0} className="top-information ">
                            <div className="container top-information-container">
                                <div className="information-left">
                                    <div className="logo-tags-container">
                                        <ListingTypeTag id={listing.id} />
                                    </div>
                                    <Typography.Title className="title">
                                        {listing.title}
                                    </Typography.Title>
                                    <Typography.Title className="sub-title" level={5}>
                                        {listing.subtitle}
                                    </Typography.Title>
                                    <div className="address">
                                        <LocationOutlinedIcon />
                                        <LocationTag />
                                    </div>
                                </div>
                                <div className="information-right d-none">
                                    <Space className="rrss">
                                        {socialMediaLink && (
                                            <Space>
                                                <Button
                                                    className="secondary"
                                                    href={`https://www.facebook.com/sharer/sharer.php?u=${socialMediaLink}`}
                                                    target={"_blank"}
                                                    icon={socialMediaIcons.Facebook}
                                                />
                                                <Button
                                                    className="secondary"
                                                    href={`https://twitter.com/intent/tweet?text=${encodeURI(
                                                        `Mira esta propiedad de ${site_name}`
                                                    )}&url=${socialMediaLink}&hashtags=${site_name},${"Propiedad"}`}
                                                    target={"_blank"}
                                                    icon={socialMediaIcons.Twitter}
                                                />
                                                <Button
                                                    className="secondary"
                                                    href={`https://wa.me/?text=${encodeURI(
                                                        `Mira esta propiedad de ${site_name}: \n${socialMediaLink}`
                                                    )}`}
                                                    target={"_blank"}
                                                    icon={socialMediaIcons.WhatsApp}
                                                />
                                            </Space>
                                        )}
                                    </Space>
                                    {!isTemporal(operationTypeId) ? (
                                        <PriceTag
                                            showOperationType={true}
                                            shortExpensesText={false}
                                            mode={mode}
                                            price={listing.price}
                                            priceVariation={listing.price_variation}
                                            commonExpenses={listing.commonExpenses}
                                            temporalCurrency={listing.temporal_currency}
                                            temporalPrice={listing.temporal_price}
                                            operationType={listing.operation_type}
                                            isProject={listing.isProject}
                                        />
                                    ) : null}
                                </div>
                            </div>
                        </Col>

                        {/* Content */}
                        <Col span={24} className="main-content">
                            <div className="container">
                                <Row>
                                    <Col span={24} lg={15} className="main-content-left">
                                        <Col span={24}>
                                            <Row gutter={[0, 32]} className="main-content-row">
                                                {/* Caracteristicas Especiales */}
                                                {listing?.features && <Col span={24}>
                                                    <Typography.Title className="d-none" level={4}>
                                                        {"Características Especiales"}
                                                    </Typography.Title>
                                                    <Row
                                                        justify="space-between"
                                                        className="features-container">
                                                        {listing?.features?.map((feature, i) => (
                                                            <Col
                                                                key={i}
                                                                span={8}
                                                                className="feature-item">
                                                                <div className="logo">
                                                                    <img
                                                                        src={feature.img}
                                                                        alt="Imagen"
                                                                    />
                                                                </div>
                                                                <div className="text">
                                                                    {feature.text}
                                                                </div>
                                                            </Col>
                                                        ))}
                                                    </Row>
                                                </Col>}

                                                {/* Caracteristicas */}
                                                <Col span={24} className="typologies-container">
                                                    <Typography.Title level={4}>
                                                        {"Características del Proyecto"}
                                                    </Typography.Title>
                                                    <TypologyTag
                                                        propertyType={propertyTypeId}
                                                        operationType={operationTypeId}
                                                        bedrooms={listing.bedrooms}
                                                        rooms={listing.rooms}
                                                        bathrooms={listing.bathrooms}
                                                        isEspecial={listing.isEspecial}
                                                        m2={
                                                            listing.minM2 > 0
                                                                ? listing.minM2
                                                                : listing.m2
                                                        }
                                                        guests={listing.guests}
                                                        loading={false}
                                                        className="property-typology-tag-desktop"
                                                        showIcons
                                                    />
                                                </Col>

                                                {/* Tour Images */}
                                                <Col span={24}>
                                                    <div className="tour-container">
                                                        <HeartFilled />
                                                        <div className="container-info">
                                                            <div className="text">
                                                                ¿Te gustan estas fotos?
                                                            </div>
                                                            <div className="sub-text">
                                                                ¡{firstLetterToUppercase(translations.coordina)} un tour para conocer nuestros
                                                                showrooms!
                                                            </div>
                                                        </div>
                                                        <div className="btn">
                                                            <Button
                                                                type="primary"
                                                                onClick={() => {
                                                                    openContactModal({
                                                                        id,
                                                                        owner: listing.owner,
                                                                        isProject: listing.isProject,
                                                                        projectId: Number(listing.id),
                                                                        defaultMessage: `Hola, vi esta propiedad en ${site_name} y quiero coordinar un tour. ¡Muchas gracias!`,
                                                                        source: "contactModal",
                                                                        propertyLink: listing.link,
                                                                        ctaToShow: {
                                                                            contact: true,
                                                                            phone: false,
                                                                            whatsapp: false
                                                                        }
                                                                    });
                                                                }}>
                                                                {firstLetterToUppercase(translations.coordina)} un tour
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </Col>

                                                {/* Information Prooject */}
                                                <Col span={24}>
                                                    <Typography.Title level={4}>
                                                        {"Información del proyecto"}
                                                    </Typography.Title>
                                                    <ProjectInfo
                                                        projectId={id}
                                                        percentageFinished={listing.percentage_finished}
                                                        percentageSold={listing.percentage_sold}
                                                        ocupation={listing.ocupation}
                                                        builder={listing.builder}
                                                        finalization={listing.finalization}
													    technicalSheet={listing.technicalSheet ?? null}
                                                    />
                                                </Col>

                                                {/* Amenities */}
                                                <Col span={24} className="facilities-container ">
                                                    <Facilities
                                                        mode={mode}
                                                        isEspecial={listing.isEspecial}
                                                        facilities={listing.facilities}
                                                    />
                                                </Col>

                                                {/* Owner Info */}
                                                {screen.xs && listing.owner ? 
                                                    <div className="padding">
                                                        <h4 className="subhead subhead-semibold high">Publicado por:</h4>
                                                        <OwnerInfo
                                                            owner={listing.owner}
                                                        />
                                                    </div> 
                                                : null}

                                                {/* Description */}
                                                {listing.description && (
                                                    <Col span={24} className="description-container">
                                                        <Description
                                                            description={listing.description}
                                                            hideInformation={false}
                                                            showTitle={true}
                                                            keepFormat
                                                        />
                                                    </Col>
                                                )}

                                                {/* Unidades */}
                                                <Col span={24}>
                                                    <Typography.Title level={4}>
                                                        {"Unidades"}
                                                    </Typography.Title>
                                                    <Units
                                                        comertialUnits={listing.commercial_units}
                                                    />
                                                </Col>

                                                {/* OfficeHours */}
                                                {Array.isArray(listing?.owner?.subsidiaries) &&
                                                    listing?.owner?.subsidiaries[0].address &&
                                                    listing?.owner?.subsidiaries[0].office_hours ? (
                                                    <Col span={24}>
                                                        <Typography.Title level={4}>
                                                            {"Horario de oficina"}
                                                        </Typography.Title>
                                                        <OfficeHours owner={listing.owner} />
                                                    </Col>
                                                ) : null}

                                                {/* Banner de solicitar plan */}
                                                {/* <Col span={24} className="plan">
                                                    <div className="plan-container">
                                                        <LikeFilled />
                                                        <div className="container-info">
                                                            <div className="title">
                                                                ¿Planeando ser dueño?
                                                            </div>
                                                            <div className="sub-title">
                                                                Decinos cuantos son tus ingresos
                                                                familiares y nosotros te hacemos un plan
                                                                a medida
                                                            </div>
                                                        </div>
                                                        <div className="btn">
                                                            <Button
                                                                type="primary"
                                                                onClick={() =>
                                                                    setKeyTab("TABKEY_LEADFORM")
                                                                }>
                                                                {firstLetterToUppercase(translations.solicita)} un plan a medida
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </Col> */}

                                                <Col span={24} className="similar-container">
                                                    <div className="container ">
                                                            <PropertySimilarsCardsActive 
                                                                id={listing.id} 
                                                                mode={mode}
                                                                ownerId={
                                                                listing.isProject ? listing.owner.id : null
                                                                }
                                                                title="Proyectos de la constructora"
                                                            />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Col>
                                    <Col span={0} lg={9} className="main-content-right">
                                        <Col
                                            span={24}
                                            className="col-information-request-small-left sticky information-box"
                                        >
                                            <InformationRequest
                                                id={listing.id}
                                                disabled={!listing.active}
                                                showCTA
                                                isProjectSpecialPage
                                                isProject={listing.isProject}
                                                slug={listing.slug}
                                                ctaToShow={{
                                                    contact: true,
                                                    phone: true,
                                                    whatsapp: true
                                                }}
                                                owner={listing.owner}
                                            />
                                        </Col>
                                    </Col>
                                </Row>
                            </div>
                        </Col>

                        {/* Backup */}
                        {listing.backup_title ? <Col span={24} className="backup-imgs">
                            <div className="container">
                                <Typography.Title level={4}>
                                    <StarFilled
                                        style={{
                                            marginRight: 12,
                                            color: "#FC7315",
                                        }}
                                    />
                                    {listing.backup_title}
                                </Typography.Title>
                                <Row className="backup-container" gutter={18}>
                                    {ImgBackup?.map((image, i) => (
                                        <Col key={i} span={24} md={6} lg={4} className="developer-item">
                                            <div className="logo">
                                                {<img src={image} alt="Image" />}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                        </Col> : null}

                        {/* Property Local Information */}
                        <Col span={24} className="padding-16">
                            <PropertyLocalInformationMap
                                isProject={listing.isProject}
                                latitude={listing.latitude}
                                longitude={listing.longitude}
                                pointType={listing?.pointType}
                                onStreetViewClick={() => {
                                    setModalTabOpen("streetView");
                                    setModalOpen(true);
                                }}
                                onMapClick={() => {
                                    setModalTabOpen("map");
                                    setModalOpen(true);
                                }}
                                id={listing.id}
                                mode={mode}
                                isEspecial={listing.isEspecial}
                            />
                        </Col>

                        {/* Sub Sidiaries && Information Request */}
                        {screen.lg ? (
                            <Col span={24} className="padding-16">
                                <div className="container pd-ir-container-big container-especial">
                                    <OnScreen
                                        onEnterView={() => setShowAffixBottom(false)}
                                        onLeaveView={() => setShowAffixBottom(true)}>
                                        <InformationRequest
                                            id={listing.id}
                                            isProject={listing.isProject}
                                            ctaToShow={{
												contact: true,
												phone: true,
												whatsapp: true
											}}
                                        >
                                            <Subsidiaries
                                                id={listing.id}
                                                mode={mode}
                                                owner={listing.owner}
                                                loading={false}
                                            />
                                        </InformationRequest>
                                    </OnScreen>
                                </div>
                            </Col>
                        ) : null}

                            {/* Seo Text */}
                            <div>
                                <SeoText />
                            </div>

                            {/* Seo Text */}
                            <div>
                                <Text>
                                    <BreadCrumbs />
                                </Text>
                            </div>

                            <div className="container">
                                <Footer />
                            </div>
                    </Row>

                    {/* Footer Image */}
					<PicHomeFooter />

                    {/*Modal de consulta*/}
                    {isVisible || modalData ? (
                        <ModalConsulta
                            modal={isVisible}
                            closeModal={closeContactModal}
                            onSuccess={closeContactModal}
                            defaultMessage={modalData.defaultMessage}
                            owner={modalData.owner}
                            id={modalData.id}
                            isProject={modalData.isProject}
                            projectId={modalData.projectId}
                            source={modalData.source}
                            propertyLink={modalData.propertyLink}
                            isAuthModalShowing={isAuthModalShowing}
                            isExpress={modalData.isExpress ?? false}
                            expressCallback={modalData.expressCallback ?? undefined}
                        />
                    ) : null}

                    {/* show Affix Bottom && Property Affix Bottom */}
                    {showAffixBottom && !screen.lg && (
                        <PropertyAffixBottom id={listing.id} mode={mode} owner={listing.owner} isProject/>
                    )}
                </div>
            </div>

            <style jsx global>
				{`
					.project-especial-single .main .main-content-right .sticky {
						top: ${showAffix ? "150px" : "84px"};
					}
				`}
			</style>
        </>
    )
}